import { Sparkle } from "lucide-react";

export const Marquee = ({ items }) => {
  const doubled = [...items, ...items];
  return (
    <div data-testid="reassurance-marquee" className="relative border-y border-[#262B3D] bg-[#0D1017] py-5 overflow-hidden">
      <div className="flex w-max animate-marquee gap-0">
        {doubled.map((item, i) => (
          <div key={i} className="flex items-center gap-4 px-8 whitespace-nowrap">
            <Sparkle className="w-3.5 h-3.5 text-primary shrink-0" />
            <span className="font-mono text-sm text-slate-400 tracking-wide">{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
